import React from 'react';
import {SectionMain, Tabs, Tab} from 'components/core';
import Singletons from 'controllers/Singletons';
import ItemsMain from './items/index';
import CategoriesMain from './categories/index';


export default function Items()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [createDialogOpen, setCreateDialogOpen] = React.useState(false);

    const editable = Singletons.currentUser.profiles.indexOf("experts") > -1 || Singletons.currentUser.profiles.indexOf("administrators") > -1;

    const tabButtonLabels = [
      "Crear Item", 
      "Nueva Categoría"
    ];

    const handleNewButtonClick = () =>
    {
      setCreateDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setSelectedTab(index);
      }
    }

    const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
      <Tab label="Items" />
      <Tab label="Categorías"/>
    </Tabs>

    const contents = [
      <ItemsMain mainDialogOpen={createDialogOpen} handleDialogClose={()=>setCreateDialogOpen(false)} />,
      <CategoriesMain mainDialogOpen={createDialogOpen} handleDialogClose={()=>setCreateDialogOpen(false)} />,
      null
    ]

    return <SectionMain title="Items de Procedimientos" buttonLabel={tabButtonLabels[selectedTab]} tabs={tabs} onButtonClick={() => handleNewButtonClick()} buttonDisabled={!editable}>
      {contents[selectedTab]}
    </SectionMain>
}

